import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CollaboratorReportComponent } from './collaborator-report.component';

const routes: Routes = [
  {
    path: '',
    component: CollaboratorReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CollaboratorReportRoutingModule {}
